import { createUseStyles } from 'react-jss';

import colors from "../../../../utils/colors";

var styles = {
  bcBlock: function bcBlock(bcWidth) {return {
      width: bcWidth || '28.5rem',
      backgroundColor: colors.neutral[100],
      padding: '1rem 2rem',
      borderRadius: '0.8rem',
      boxSizing: 'border-box',
      marginBottom: '2rem'
    };},
  shortName: {
    fontSize: '1.4rem',
    fontWeight: '400',
    color: colors.neutral[700],
    margin: 0
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map